import React from "react";

import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import { CardContent } from "@material-ui/core";

import { formateDateTime } from "../../../utils";

const useStyles = makeStyles(theme => ({
  marginY: {
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2)
  },
  marginBottom: {
    marginBottom: theme.spacing(2)
  }
}));

const MailLogView = ({ subject, date, from, to, body }) => {
  const classes = useStyles();

  return (
    <Card variant="outlined" className={classes.marginY}>
      <CardContent>
        <Grid container direction="column">
          <Typography>
            Subject: <strong>{subject}</strong>
          </Typography>
          <Typography>Date: {formateDateTime(date)}</Typography>
          <Typography>From: {from}</Typography>
          <Typography className={classes.marginBottom}>To: {to}</Typography>
          <div dangerouslySetInnerHTML={{ __html: body }}></div>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default MailLogView;
